(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.impersonation = mod.exports;
  }
})(this, function (exports, _react) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ImpersonationOverlay = exports.getImpersonationHeader = exports.getAssumedUser = exports.clearAssumedUser = exports.assumeUser = undefined;
  var _react2 = _interopRequireDefault(_react);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var ASSUMED_USER_COOKIE = 'pga_org_assumed_user';
  var ASSUME_USER_RETURN_URL_COOKIE = 'pga_org_assume_user_return_url';
  var ONE_YEAR = 365 * 24 * 60 * 60;
  var assumeUser = function assumeUser(_ref) {
    var id = _ref.id;
    _setCookieValue(ASSUMED_USER_COOKIE, JSON.stringify({
      id: id
    }));
    _setCookieValue(ASSUME_USER_RETURN_URL_COOKIE, encodeURIComponent(window.location.href));
  };
  var clearAssumedUser = function clearAssumedUser() {
    var redirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var returnUrl = _getCookieValue(ASSUME_USER_RETURN_URL_COOKIE);
    _clearCookie(ASSUMED_USER_COOKIE);
    _clearCookie(ASSUME_USER_RETURN_URL_COOKIE);
    if (redirect) {
      window.location.href = returnUrl;
    }
  };
  var getAssumedUser = function getAssumedUser() {
    var cookie = _getCookieValue(ASSUMED_USER_COOKIE);
    return cookie ? JSON.parse(cookie) : null;
  };
  var getImpersonationHeader = function getImpersonationHeader() {
    var user = getAssumedUser();
    return user ? {
      'X-PGA-Impersonation': user.id
    } : {};
  };
  var ImpersonationOverlay = function ImpersonationOverlay() {
    var assumedUser = getAssumedUser();
    if (!assumedUser) return null;
    return _react2.default.createElement('div', {
      style: {
        position: 'fixed',
        top: 0,
        zIndex: 1300,
        width: '100%',
        backgroundColor: 'rgba(255, 91, 51, 0.8)',
        textAlign: 'center',
        padding: '0'
      }
    }, _react2.default.createElement('div', {
      style: {
        display: 'inline-block',
        marginRight: '16px',
        textTransform: 'uppercase',
        fontWeight: 600,
        color: 'black'
      }
    }, 'You are currently impersonating PGA ID #', assumedUser.id), _react2.default.createElement('button', {
      onClick: clearAssumedUser
    }, 'I\'m done'));
  };
  var _getCookieDomain = function _getCookieDomain() {
    if (typeof window !== 'undefined') {
      if (window.location.origin.includes('localhost')) {
        return 'localhost';
      }
      if (window.location.origin.includes('.pga.local')) {
        return '.pga.local';
      }
      if (window.location.origin.includes('.sandboxpga.org')) {
        return '.sandboxpga.org';
      }
      return '.pga.org';
    }
  };
  var _getCookieValue = function _getCookieValue(cookieName) {
    var cookies = document.cookie.split(';');
    var cookiePairs = cookies.map(function (c) {
      return c.split('=');
    });
    var cookieKeyValue = cookiePairs.find(function (cp) {
      return cp[0].trim() === cookieName;
    });
    return cookieKeyValue ? decodeURIComponent(cookieKeyValue[1]) : null;
  };
  var _setCookieValue = function _setCookieValue(cookieName, value) {
    document.cookie = cookieName + '=' + value + '; domain=' + _getCookieDomain() + '; path=/; max-age=' + ONE_YEAR + '; SameSite=Lax; ' + (process.env.NODE_ENV !== 'development' ? 'Secure;' : '');
  };
  var _clearCookie = function _clearCookie(cookieName) {
    document.cookie = cookieName + '=; domain=' + _getCookieDomain() + '; path=/; max-age=0;';
  };
  exports.assumeUser = assumeUser;
  exports.clearAssumedUser = clearAssumedUser;
  exports.getAssumedUser = getAssumedUser;
  exports.getImpersonationHeader = getImpersonationHeader;
  exports.ImpersonationOverlay = ImpersonationOverlay;
});